/**
 * @generated SignedSource<<865d7419ab7db52b92b6fb9b7b5e5637>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RequestDocumentUploadInput = {
  byteSize: number;
  contentType: string;
  organizationId?: string | null | undefined;
  systemId?: string | null | undefined;
};
export type useDocumentMutationsRequestUploadMutation$variables = {
  input: RequestDocumentUploadInput;
};
export type useDocumentMutationsRequestUploadMutation$data = {
  readonly requestDocumentUpload: {
    readonly headers: ReadonlyArray<{
      readonly name: string;
      readonly value: string;
    }>;
    readonly objectKey: string;
    readonly uploadUrl: string;
  };
};
export type useDocumentMutationsRequestUploadMutation = {
  response: useDocumentMutationsRequestUploadMutation$data;
  variables: useDocumentMutationsRequestUploadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DocumentUploadSlot",
    "kind": "LinkedField",
    "name": "requestDocumentUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "uploadUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "objectKey",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "DocumentUploadHeader",
        "kind": "LinkedField",
        "name": "headers",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useDocumentMutationsRequestUploadMutation",
    "selections": (v1/*: any*/),
    "type": "RootMutationType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDocumentMutationsRequestUploadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "873cced1501524b464c3ec00ee1e4736",
    "id": null,
    "metadata": {},
    "name": "useDocumentMutationsRequestUploadMutation",
    "operationKind": "mutation",
    "text": "mutation useDocumentMutationsRequestUploadMutation(\n  $input: RequestDocumentUploadInput!\n) {\n  requestDocumentUpload(input: $input) {\n    uploadUrl\n    objectKey\n    headers {\n      name\n      value\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "bd7e15f287cd04872d4b91685c43f624";

export default node;
